<h1 mat-dialog-title>Date Range</h1>
<div mat-dialog-content style="height: 90px;">
  <form #basicForm="ngForm">
    <div class="display-flex form-row flex-items-centered">
      <div class="flex-grow-1">
        <div class="merlin-control">
          <div class="label-cont">
            <label class="mer-label">Start Date</label>
          </div>
          <div class="control-cont">

            <div class="display-flex flex-items-centered merlin-date position-relative">
              <div class="flex-grow-1">
                <input matInput [matDatepicker]="startDatePicker" class="mer-date-picker" name="startDate" [(ngModel)]="startDate" placeholder="dd/mm/yyyy">
              </div>
              <div class="position-absolute to-right">
                <mat-datepicker-toggle matSuffix [for]="startDatePicker">
                  <img class="date-picker-img" src="/assets/images/dateIcon.svg" matDatepickerToggleIcon />
                </mat-datepicker-toggle>
              </div>
              <div>
                <mat-datepicker #startDatePicker></mat-datepicker>
              </div>
            </div>

          </div>
            </div>
          </div>
      <div class="flex-sep"></div>
      <div class="flex-grow-1">
        <div class="merlin-control">
          <div class="label-cont">
            <label class="mer-label">End Date</label>
          </div>
          <div class="control-cont">

            <div class="display-flex flex-items-centered merlin-date position-relative">
              <div class="flex-grow-1">
                <input matInput [matDatepicker]="endDatePicker" class="mer-date-picker" name="endDate" [(ngModel)]="endDate" placeholder="dd/mm/yyyy">
              </div>
              <div class="position-absolute to-right">
                <mat-datepicker-toggle matSuffix [for]="endDatePicker">
                  <img class="date-picker-img" src="/assets/images/dateIcon.svg" matDatepickerToggleIcon />
                </mat-datepicker-toggle>
              </div>
              <div>
                <mat-datepicker #endDatePicker></mat-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>
</div>

<div mat-dialog-actions class="display-flex">
  <div class="flex-grow-1"></div>
  <button class="main-btn empty-back-btn margin-m" [mat-dialog-close]="false">CANCEL</button>
  <button class="main-btn filled-back-btn" (click)="applySearch()" cdkFocusInitial [disabled]="basicForm.invalid">Apply</button>
</div>
